<template>
  <div class="container-center-horizontal">
    <div class="price-375 screen">
      <div class="overlap-group51">
        <img class="union-6" src="img/union-12.svg" alt="Union" @click="drawer = true" />
        <img class="logo-01-4" src="img/logo-01-2.svg" alt="logo-01" />
      </div>
      <h1 class="algt-report-price-list-1 plusjakartasans-bold-mine-shaft-24px">{{ algtReportPriceList }}</h1>
      <group47 :algtReportPriceListPdf="globalData.algtReportPriceListPdf"/>

      <!-- Price Table Section -->
      <div class="price-table-section">
        <PriceTable :priceData="priceListData" viewSize="small" />
      </div>

      <group47 :className="group47Props.className" :algtReportPriceListPdf="globalData.algtReportPriceListPdf"/>
      <foot v-bind="globalData" />
      <el-drawer direction="ltr" :visible.sync="drawer" :with-header="false" size="50%">
        <left-nav/>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import LeftNav from "./components/Navbar";
import Foot from "./components/Foot375";
import Group47 from "./price/Group47";
import PriceTable from "../components/PriceTable";
import priceListData from "../price-list-2025";

export default {
  name: "Price375",
  components: {
    LeftNav,
    Foot,
    Group47,
    PriceTable,
  },
  data() {
    return {
      drawer: false,
      priceListData,
    }
  },
  props: [
    "globalData",
    "algtReportPriceList",
    "group47Props",
  ],
};
</script>

<style lang="sass" scoped>
@import '../../variables'

.price-375
  align-items: center
  background-color: $selago
  display: flex
  flex-direction: column
  min-height: 100vh
  position: relative
  width: 375px

.overlap-group51
  align-items: flex-start
  background-color: $white
  box-shadow: 0px 1px 16px #33333326
  display: flex
  gap: 109px
  height: 47px
  min-width: 375px
  padding: 10px 15px

.union-6
  align-self: center
  height: 17px
  width: 19px

.logo-01-4
  height: 26px
  width: 90px

.algt-report-price-list-1
  align-self: flex-start
  letter-spacing: 0
  line-height: normal
  margin-left: 10px
  margin-top: 19px
  min-height: 30px

.price-table-section
  width: 100%
  max-width: 355px
  margin: 20px auto
</style>